import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/viadeo': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M276.2 150.5V151.2C258.3 98.6 233.6 47.8 205.4 0 248.7 29.2 272.4 100 276.2 150.5zM308.9 272.2C316.5 290.4 319.9 309.7 319.9 329.2 319.9 406.9 262.1 470.2 182.1 468.6L185.9 468.3C260.1 421.6 295.2 349.7 295.2 263.2 295.2 225.1 288.7 187.3 276.3 151.2 277.3 162.9 277.3 174.9 277.3 186.6 277.3 278.4 259.2 428.2 160.7 466.6 95 455.2 49.4 398 49.4 329.2 49.4 253.6 106.8 186.9 184.8 186.9 201.6 186.9 218.5 190 233.9 196.5 235.6 181.4 240.4 166.6 247.3 153.2 227.4 146 206.1 142.5 184.8 142.5 23.3 142.5-53.9 338.4 54.9 456.2 122.8 530.8 246.9 530.1 314.7 456.2 371.3 394.9 375.6 313.8 351.1 255.2 338.4 263.2 324 269.1 308.9 272.2zM418.1 11.7C387.1 78.2 336.8 58.9 302.3 91.8 289.9 103.8 281.7 125.8 281.7 142.3 281.7 156.4 286.2 169.4 293.7 181.1 341.1 170.1 392 135.1 411.9 90.4 411.2 95.9 407.1 104.8 404.7 109.6 384.4 145.3 340.1 175.2 305 194.5 319.8 208.9 338.7 220.3 360 220.3 439 220.3 470.1 85.7 418.1 11.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/viadeo.js
// module id = jeZL
// module chunks = 144